module.exports = __webpack_public_path__ + "static/01-efcf55d5f41157a382a97fd5a597aa36.jpg";